export const serverBaseURL = (process.env.NODE_ENV === 'production') ? 'https://zeyuni.uncledev.net': 'http://localhost:4000'